import React, { useEffect } from "react";
import HeroSection from "../components/pages/homepage/HeroSection";
import ZakatConsultancySection from "../components/pages/homepage/ZakatConsultancySection ";
import FeaturesSection from "../components/pages/homepage/FeaturesSection";
import ServicesSection from "../components/pages/homepage/ServicesSection";
import CategoryCarousel from "../components/pages/homepage/CategoryCarousel";
import ContactForm from "../components/pages/homepage/ContactForm";
import { useDispatch, useSelector } from "react-redux";
import { fetcHomehData } from "../redux/slices/HomeSlice";
import Loader from "../components/shared/Loader";
import MetaTags from "../components/shared/MetaTags";
export const Home = () => {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.home);
  useEffect(() => {
    dispatch(fetcHomehData());
  }, [dispatch]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }
  return (
    <>
      <MetaTags />
      <HeroSection data={data?.data?.slider} />
      <ZakatConsultancySection data={data?.data?.about} />
      <FeaturesSection data={data?.data?.features} />
      <ServicesSection data={data?.data?.services} />
      {/* <CategoryCarousel data={data?.data?.testimonials} /> */}
      <ContactForm data={data?.data?.settings} />
    </>
  );
};
